class SaveBookingPreferenceLocationDto {
  id?: string;
  location!: string;
  comments?: string;
  group!: string;
  displayOrder!: string;
}

export default SaveBookingPreferenceLocationDto;
